import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import {
  initialValues,
  validationSchema,
} from "../../../componentes/Administrador_EditarPerfil";
import { Segment, Grid, Header } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { estiloColores } from "../../../estilos/colores";
import Swal from "sweetalert2";
import { apiUsuario } from "../../../api/usuario";
import { ENTORNO } from "../../../utils/constantes";
import {
  setemail,
  setNombre,
  setApellido,
  setTelefono,
  setTitulo,
  setavatar,
  getrole,
} from "../../../utils/variablesLocales";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import HomeIcon from "@mui/icons-material/Home";
import { TextField } from "@material-ui/core";
import {
  editar_perfil,
  general,
  nombre,
  apellido,
  email,
  telefono,
} from "../../../utils/traductor";

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const apiusuario = new apiUsuario();

export function EditarPerfil(props) {
  setTitulo("Editar perfil");

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        //guardar cambios
        setemail(formik.values.email);
        setNombre(formik.values.nombre);
        setApellido(formik.values.apellido);
        setTelefono(formik.values.telefono);
        setavatar(formik.values.avatar.replace("uploads/", ""));

        const respuesta = await apiusuario.actualizarAvatarAdministrador(
          formik.values.nombre,
          formik.values.apellido,
          formik.values.email,
          formik.values.telefono
        );

        if (respuesta.status === 200) {
          Swal.fire({
            title: "",
            text: "Cambios registrados correctamente",
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: estiloColores.Azul,
          }).then(function () {});
        } else {
          Swal.fire({
            title: "Error!",
            text: "Error al guardar cambios",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: estiloColores.Gris,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  const navigate = useNavigate();

  const navigateToInicio = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Administrador/Inicio");
  };

  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Administrador") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
        ///////////////////////////////////////////////////////

        document.body.style.zoom = "100%";
      } catch (error) {
        console.error(error);
      }
    })();
  });

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <form onSubmit={formik.handleSubmit}>
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                onClick={navigateToInicio}
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <HomeIcon />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {editar_perfil}
              </Typography>
              <IconButton
                size="large"
                aria-label="display more actions"
                edge="end"
                color="inherit"
                type="submit"
              >
                <CheckIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Box sx={{ my: 2 }}>
              <Segment style={estiloSegmento.Pasajero}>
                <Grid
                  textalign="center"
                  container
                  style={{ padding: "1em 0em" }}
                >
                  <div className="ingresar">
                    <Grid.Row>
                      <Grid.Column style={{ maxWidth: 450 }}>
                        <Box
                          //component="form"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            "& > :not(style)": { m: 1, width: "100%" },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          {/* <Header as="h3">{general}</Header> */}
                          <TextField
                            id="nombre"
                            label={nombre}
                            placeholder={nombre}
                            variant="standard"
                            name="nombre"
                            type="text"
                            value={formik.values.nombre}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.nombre &&
                              Boolean(formik.errors.nombre)
                            }
                            helperText={
                              formik.touched.nombre && formik.errors.nombre
                            }
                          />
                          <TextField
                            id="apellido"
                            label={apellido}
                            placeholder={apellido}
                            variant="standard"
                            name="apellido"
                            type="text"
                            value={formik.values.apellido}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.apellido &&
                              Boolean(formik.errors.apellido)
                            }
                            helperText={
                              formik.touched.apellido && formik.errors.apellido
                            }
                          />
                          <br></br>
                          {/* <Header as="h3">Contacto</Header> */}
                          <TextField
                            id="email"
                            label={email}
                            placeholder={email}
                            disabled
                            variant="standard"
                            name="email"
                            type="text"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.email &&
                              Boolean(formik.errors.email)
                            }
                            helperText={
                              formik.touched.email && formik.errors.email
                            }
                          />
                          <TextField
                            id="telefono"
                            label={telefono}
                            placeholder={telefono}
                            variant="standard"
                            name="telefono"
                            type="text"
                            value={formik.values.telefono}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.telefono &&
                              Boolean(formik.errors.telefono)
                            }
                            helperText={
                              formik.touched.telefono && formik.errors.telefono
                            }
                          />
                        </Box>
                      </Grid.Column>
                    </Grid.Row>
                  </div>
                </Grid>
              </Segment>
            </Box>
          </Container>
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        </React.Fragment>
      </form>
    </div>
  );
}
